import React, { createContext, useState, useEffect, useContext } from 'react';
import api from './api.js';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // Stores logged-in user's token
  const [loading, setLoading] = useState(true); // To handle loading state
  const [fulluser, setfullUser] = useState(null); // Stores logged-in user's data with id
  const [vendordetails, setvendordetails] = useState(null); // Stores vendor business details
  const [hasRedirectedOnce, setHasRedirectedOnce] = useState(false);

  // Load user token from localStorage on app initialization
  useEffect(() => {
    const savedUserId = localStorage.getItem('user_id');
    if (savedUserId) {
      setUser(savedUserId); // Set user_id as user
     // fetchUserData(); // Load user data after setting user_id
    }
    setLoading(false);
  }, []);

  // Login function to set user and user_id
  const login = (token, userId) => {
    setUser(userId); // Set user_id as user
    localStorage.setItem('user_id', userId);
    // Store JWT token for API requests
    if (token) {
      localStorage.setItem('jwt_token', token);
    }
    // fetchUserData(); // Load user data after login
  };

  // Refresh user data (can be called from anywhere)
  const refreshUser = () => {
    // fetchUserData();
  };

  // Logout function to clear user and user_id
  const logout = () => {
    setUser(null);
    setfullUser(null);
    setvendordetails(null);
    localStorage.removeItem('access_token');
    localStorage.removeItem('jwt_token');
    localStorage.removeItem('device_token');
    localStorage.removeItem('user_id');
  };

  useEffect(() => {
    fetchUserData(); // Load user data on component mount
  }, []);

  const fetchUserData = async () => {
    const userId = localStorage.getItem('user_id'); 
    if (userId) {
      try {
        // Get vendor details using user_id (with JWT token)
        const userResponse = await api.get('/vendor/get-details-by-id');
        
        console.log('Auth vendor details response:', userResponse.data);
        
        if (userResponse.data.status === 'success' && userResponse.data.data) {
          // Set full user data (this will include user.id)
          setfullUser(userResponse.data.data);
          console.log('Full user data set:', userResponse.data.data);
          
          // Then fetch vendor details
           const response = await api.get('/vendor/details/' + userResponse?.data?.data?.id);
          setvendordetails(response.data);
        } else {
          console.error('Invalid auth response:', userResponse.data);
          setfullUser(null);
          setvendordetails(null);
        }
      } catch (error) {
        console.error('Error fetching user details:', error);
        console.error('Error response:', error.response?.data);
        setfullUser(null);
        setvendordetails(null);
      }
    }
  };

  return (
    <AuthContext.Provider value={{ user, setUser, fulluser, setfullUser, vendordetails, setvendordetails, fetchUserData, refreshUser, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
